export default __webpack_public_path__ + "static/media/area-70.96ac6de5.jpg";